/**
 * Portal Inbox Fragment
 * Date-range filtering for the guest portal's received transfers, and the
 * permission check that runs before a download starts.
 *
 * Only the controls the guest touches carry data attributes. The hidden fields
 * behind them keep their ids: those names are the legacy backend's contract,
 * not this module's.
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

function setMode(form, mode) {
    form.querySelectorAll('input[name="timeperiod"]').forEach((radio) => {
        radio.checked = radio.value === mode;
    });
}

// The picker is one date input; the backend wants month, day and year apart.
function splayDate(inputId, monthId, dayId, yearId) {
    const value = document.getElementById(inputId).value; // "YYYY-MM-DD"
    if (!value) return false;
    const parts = value.split('-');
    if (parts.length !== 3) return false;
    document.getElementById(yearId).value = String(parseInt(parts[0], 10));
    document.getElementById(monthId).value = String(parseInt(parts[1], 10));
    document.getElementById(dayId).value = String(parseInt(parts[2], 10));
    return true;
}

function showDownloadError(html) {
    const container = document.querySelector('[data-portal-inbox-error]');
    if (container) container.innerHTML = html;
}

// ============================================================================
// Inbox Handlers
// ============================================================================

const PortalInboxHandlers = {
    /** "7 / 14 / 30 days" — switch to the simple range and refilter. */
    onQuickRange(event, element) {
        const form = element.form;
        if (!form) return;
        setMode(form, 'simple');
        const days = document.getElementById('simpleTimePeriod');
        if (days) days.value = element.dataset.portalInboxRange;
        form.requestSubmit();
    },

    /** A picker changed. Both have to be filled before the range means anything. */
    onDateChange(event, element) {
        const form = element.form;
        if (!form) return;
        const startOk = splayDate('startDate', 'beginMonth', 'beginDay', 'beginYear');
        const endOk = splayDate('endDate', 'endMonth', 'endDay', 'endYear');
        if (!startOk || !endOk) return;
        setMode(form, 'date');
        form.requestSubmit();
    },

    /**
     * Ask whether the download is still allowed before starting it. The server
     * answers a refusal as rendered HTML, which goes straight into the page —
     * following the link instead would replace the page with the error.
     */
    onDownload(event, element) {
        event.preventDefault();
        showDownloadError('');
        fetch(element.dataset.checkUrl)
            .then((response) => {
                if (response.status >= 400) {
                    return response.text().then(showDownloadError);
                }
                if (response.status === 200) {
                    window.location.href = element.dataset.downloadUrl;
                }
                return undefined;
            })
            .catch(() => {
                showDownloadError(
                    '<div class="bg-red-50 border border-red-200 rounded-lg p-2 max-w-md">' +
                    '<p class="text-sm text-red-800">An error occurred. Please try again.</p></div>'
                );
            });
    },
};

// ============================================================================
// Initialization
// ============================================================================

export function initPortalInbox() {
    if (initialized) return;
    initialized = true;

    Events.on('click', 'portal-inbox-range', PortalInboxHandlers.onQuickRange);
    Events.on('change', 'portal-inbox-date', PortalInboxHandlers.onDateChange);
    Events.on('click', 'portal-inbox-download', PortalInboxHandlers.onDownload);
}
